import styled from "../../styled";
import lighten from "polished/lib/color/lighten";
export const OrderNumber = styled('div') `
  font-family: ${({ theme }) => theme.font.header};
  background: ${({ theme }) => theme.colors.primary};
  color: ${({ theme }) => theme.colors.primary_text};
  font-size: 18px;
  font-weight: 600;
  padding: 8px 12px;
  border-radius: 30px;

  ${props => props.shouldFlash
    ? `
    animation: flash-order-number 1.5s infinite;

    &:hover {
      animation-play-state: paused;
    }

		@keyframes flash-order-number {
			0% {
				background-color: ${props.theme.colors.primary};
			}
			50% {
				background-color: ${lighten(0.2, props.theme.colors.primary)};
			}
			100% {
				background-color: ${props.theme.colors.primary};
			}
		}
  `
    : ''}
`;
//# sourceMappingURL=order-number.js.map